import { PAIR_AMOUNT_DECIMALS } from '@ui/constants/numbersDecimals';
import { POSITION_BUFFER_THRESHOLD } from '@ui/constants/uiConfig';
import { toBigValue } from '@ui/lib/bignumber';
import BigNumber from 'bignumber.js';

/**
 * according to APX, for positionSize if reach current leverageMargin 's max leverage, will need to deduct the 0.5%, to avoid reach max leverage error
 */
export function getOpenTradeQty({
  positionSize,
  entryPrice,
  isLeverageReachMax,
}: {
  positionSize: BigNumber;
  entryPrice: BigNumber;
  isLeverageReachMax: boolean;
}): bigint {
  const countInPositionSize = isLeverageReachMax
    ? positionSize.multipliedBy(1 - POSITION_BUFFER_THRESHOLD)
    : positionSize;

  const pairPositionSize = countInPositionSize.div(entryPrice);
  // user input entryPrice low enough will result in infinite
  if (!pairPositionSize.isFinite()) return 0n;

  const qty = toBigValue(
    countInPositionSize.div(entryPrice),
    PAIR_AMOUNT_DECIMALS,
  );

  return qty;
}
